import { useMutation, useQueryClient } from 'react-query';

import { status200 } from '../status.utils';
import axios from '../axios/axiosInstance';
import apiPaths from '../apiPaths';

const importFromCarto = (data, performActionsAfterUpload, setErrors) => {
  return axios
    .post(apiPaths.importFromCarto, data, status200)
    .then((resp) => {
      performActionsAfterUpload();
      return resp.data;
    })
    .catch((e) => {
      setErrors(e.data.error);
    });
};

const useImportFromCarto = (performActionsAfterUpload, setErrors) => {
  const queryClient = useQueryClient();

  return useMutation((values) => importFromCarto(values, performActionsAfterUpload, setErrors), {
    onSuccess: (success) => {
      queryClient.resetQueries(['data_set']);
      return success;
    },
    onError: (error) => error,
    onSettled: () => {
      queryClient.invalidateQueries(['data_set']);
    },
  });
};
export default useImportFromCarto;
